import React, { useState } from "react";
import CartBannerComponent from "../../Components/ProdectBanner/CartBannerComponent";
import "./ContactUs.css";

const ContactUs = () => {
  const [formData, setFormData] = useState({ name: "", email: "", subject: "", message: "" });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
  };

  return (
    <div>
      <CartBannerComponent title="Contact Us" />
      <div className="container contact-container my-5">
        <div className="row">

          <div className="col-md-4 mb-4">
            <div className="contact-info p-4">
              <h4 className="font-weight-bold mb-4">Get In Touch</h4>

              <div className="contact-item d-flex mb-4">
                <div className="contact-icon"><i className="fa fa-map-marker" /></div>
                <div className="ml-3">
                  <h6 className="font-weight-bold mb-1">Address</h6>
                  <p className="text-muted small mb-0">Suite 6B, House 8A/10, Doreen Tower, Road 13, Dhanmondi, Dhaka 1209, Bangladesh</p>
                </div>
              </div>

              <div className="contact-item d-flex mb-4">
                <div className="contact-icon"><i className="fa fa-phone" /></div>
                <div className="ml-3">
                  <h6 className="font-weight-bold mb-1">Phone</h6>
                  <p className="text-muted small mb-0">+880 1819 250309</p>
                </div>
              </div>

              <div className="contact-item d-flex mb-4">
                <div className="contact-icon"><i className="fa fa-envelope" /></div>
                <div className="ml-3">
                  <h6 className="font-weight-bold mb-1">Email</h6>
                  <p className="text-muted small mb-0">info@techknowgram.com</p>
                </div>
              </div>

              <div className="contact-item d-flex mb-4">
                <div className="contact-icon"><i className="fa fa-clock-o" /></div>
                <div className="ml-3">
                  <h6 className="font-weight-bold mb-1">Business Hours</h6>
                  <p className="text-muted small mb-0">Sunday – Thursday: 9:00 AM – 6:00 PM</p>
                  <p className="text-muted small mb-0">Friday – Saturday: Closed</p>
                </div>
              </div>

              <div className="social-links mt-4">
                <h6 className="font-weight-bold mb-3">Follow Us</h6>
                <div className="d-flex gap-2">
                  {["fa-facebook", "fa-twitter", "fa-instagram", "fa-linkedin"].map((icon, i) => (
                    <a key={i} href="#" className="social-link mr-2">
                      <i className={`fa ${icon}`} />
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-8 mb-4">
            <div className="contact-form-wrapper p-4">
              <h4 className="font-weight-bold mb-4">Send Us a Message</h4>

              {submitted ? (
                <div className="alert alert-success">
                  <i className="fa fa-check-circle mr-2" />
                  <strong>Message Sent!</strong> Thank you for contacting us. We'll get back to you within 24 hours.
                </div>
              ) : (
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="font-weight-bold small">Your Name *</label>
                      <input type="text" name="name" className="form-control" required value={formData.name} onChange={handleChange} placeholder="Full name" />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="font-weight-bold small">Email Address *</label>
                      <input type="email" name="email" className="form-control" required value={formData.email} onChange={handleChange} placeholder="your@email.com" />
                    </div>
                  </div>
                  <div className="mb-3">
                    <label className="font-weight-bold small">Subject *</label>
                    <input type="text" name="subject" className="form-control" required value={formData.subject} onChange={handleChange} placeholder="How can we help?" />
                  </div>
                  <div className="mb-3">
                    <label className="font-weight-bold small">Message *</label>
                    <textarea name="message" className="form-control" rows="5" required value={formData.message} onChange={handleChange} placeholder="Write your message here..." />
                  </div>
                  <button type="submit" className="btn btn-primary px-4">Send Message</button>
                </form>
              )}
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default ContactUs;